import { createSlice } from '@reduxjs/toolkit';

import { getPrevNextIds } from '../../helpers/common';

import { clearNotification, fetchNotification, fetchNotifications, snoozeNotification } from '../actions/notifications';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    alerts: [],
    alertsCount: 0,
    list: [],
    data: null,
    error: null,
    loading: false,
    notification: null,
    selectedAlerts: [],
    sortedData: [],
    unreadNotificationCount: 0
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    },
    setSelectedAlerts: (state, action) => {
      state.selectedAlerts = action.payload;
    },
    setNotificationList: (state, action) => {
      state.list = action.payload;
    },
    setNotificationState: (state, action) => {
      return { ...action.payload };
    }
  },
  extraReducers: builder => {
    builder
      // Fetch Notifications
      .addCase(fetchNotifications.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.data = action.payload;
        state.alerts = action.payload?.notifications;
        state.alertsCount = action.payload?.count;
        state.loading = false;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Notification
      .addCase(fetchNotification.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotification.fulfilled, (state, action) => {
        const { prev_id, next_id } = state.sortedData?.length
          ? getPrevNextIds(state.sortedData, action.payload?.id)
          : { prev_id: action.payload.prev_id, next_id: action.payload.next_id };
        state.notification = { ...action.payload, prev_id, next_id };
        state.loading = false;
      })
      .addCase(fetchNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Clear Notification
      .addCase(clearNotification.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(clearNotification.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(clearNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Snooze Notification
      .addCase(snoozeNotification.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(snoozeNotification.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(snoozeNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData, setNotificationList, setNotificationState } = notificationsSlice.actions;
export default notificationsSlice.reducer;
